var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.view == 'graficos')?_c('div',[_c('nav-component'),_c('ingresos'),_c('sucursales'),_c('empleados'),_c('gastos'),_c('clientes'),_c('articulos'),_c('cheques')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }